"use strict";

angular.module('app.currentUser.authentication.constant', [])
  .constant('AUTHENTICATION', {
    NON_AUTH_STATES: [
      'welcome',
      'app\.information',
      'app\.login',
      'app\.mobileLogin',
      'app\.registration',
      'app\.passwordReset',
      'app\.locked',
      'app\.gotw',
      'app\.brand',
      'app\.changeEmail.verify',
      'app\.sessionTimeout',
      'app\.pricing',
      'app\.promo'
    ],
    DEFAULT_AUTH_STATE: 'welcome',
    NON_AUTH_TO_LOGIN: [
      'app\.purchase'
    ],
    REQUIRE_SUBSCRIPTION: [
      'app\.myHockeyTv'
    ],
    NO_SUBSCRIPTION_STATE: 'app.pricing',

    NON_AHL_STATES: [
      'app\.myHockeyTv\.collegeCommitments',
      'app\.myHockeyTv\.playersToWatch'
    ]
  });


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/currentUser/authentication/constant.js